import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';

@Injectable()
export class AlertService {
    constructor(public alertCtrl: AlertController) { }

    presentAlert(title: string, message: string) {
        return new Promise((resolve, reject) => {
            let alert = this.alertCtrl.create();
            alert.setTitle(title);
            alert.setMessage('<strong>'+message+'</strong>');
            alert.addButton({
                text: 'OK',
                handler: () => {
                    resolve();
                }
            });

            alert.present(alert).then();
        });
    }

    presentErrorAlert(message: string) {
        return this.presentAlert("An error has occurred.", message);
    }

    presentAlertWithCallback(title: string, message: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const confirm = this.alertCtrl.create({
                title,
                message,
                buttons: [{
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        confirm.dismiss().then(() => resolve(false));
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        confirm.dismiss().then(() => resolve(true));
                    }
                }]
            });

            return confirm.present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/util/alert.service.ts